import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Instagram } from "lucide-react";
import WhatsAppIcon from "@/components/WhatsAppIcon";
import { LOGO_LIGHT, NAV_LINKS, PHONE_DISPLAY, PHONE_TEL, EMAIL, WHATSAPP_URL, u, IMG } from "@/lib/site";

const testId = (label) => label.toLowerCase().replace(/\s+/g, "-");

export default function Footer() {
    return (
        <footer className="relative overflow-hidden bg-ink text-cream" data-testid="site-footer">
            <img
                src={u(IMG.grainDark, 1600)}
                alt=""
                aria-hidden="true"
                loading="lazy"
                decoding="async"
                className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-[0.07]"
            />
            <div className="relative mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-20">
                <div className="grid gap-12 lg:grid-cols-12">
                    <div className="lg:col-span-5">
                        <img
                            src="/LOGO%20COMPLETE.jpeg"
                            alt="ISHAAN WORLDLINK LLP"
                            className="h-16 w-auto"
                            loading="lazy"
                            decoding="async"
                        />
                        <p className="mt-6 max-w-sm text-sm leading-relaxed text-cream/70">
                            Teak, Softwood and Hardwood — supplied to customers across India
                            from Gandhidham, Gujarat. Now moving toward in house value-added teak processing.
        
                        </p>
                        <a
                            href={`mailto:${EMAIL}`}
                            data-testid="footer-email-link"
                            className="mt-5 inline-flex items-center gap-2 text-sm text-cream/85 underline-offset-4 transition-colors hover:text-gold hover:underline"
                        >
                            <Mail className="h-4 w-4 text-gold" /> {EMAIL}
                        </a>
                    </div>

                    <div className="lg:col-span-3">
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">
                            Navigate
                        </p>
                        <ul className="mt-5 space-y-3">
                            {NAV_LINKS.map((l) => (
                                <li key={l.to}>
                                    <Link
                                        to={l.to}
                                        data-testid={`footer-nav-${testId(l.label)}`}
                                        className="text-sm text-cream/75 transition-colors hover:text-cream"
                                    >
                                        {l.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="lg:col-span-4">
                        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">
                            Connect
                        </p>
                        <div className="mt-5 flex flex-col gap-3">
                            <a
                                href={PHONE_TEL}
                                data-testid="footer-call-link"
                                className="group inline-flex items-center gap-4 border border-linedark px-5 py-4 transition-colors duration-300 hover:border-teak hover:bg-teak/10"
                            >
                                <Phone className="h-5 w-5 shrink-0 text-gold" />
                                <span>
                                    <span className="block text-[11px] uppercase tracking-[0.2em] text-cream/50">
                                        Call us
                                    </span>
                                    <span className="block text-sm font-semibold">{PHONE_DISPLAY}</span>
                                </span>
                            </a>
                            <a
                                href={WHATSAPP_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-whatsapp-link"
                                className="group inline-flex items-center gap-4 border border-linedark px-5 py-4 transition-colors duration-300 hover:border-[#25D366] hover:bg-[#25D366]/10"
                            >
                                <WhatsAppIcon className="h-5 w-5 shrink-0 text-[#25D366]" />
                                <span>
                                    <span className="block text-[11px] uppercase tracking-[0.2em] text-cream/50">
                                        WhatsApp
                                    </span>
                                    <span className="block text-sm font-semibold">{PHONE_DISPLAY}</span>
                                </span>
                            </a>
                            <a
                                href="https://www.instagram.com/ishaan_worldlink/"
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="footer-instagram-link"
                                className="group inline-flex items-center gap-4 border border-linedark px-5 py-4 transition-colors duration-300 hover:border-pink-500 hover:bg-pink-500/10"
                            >
                                <Instagram className="h-5 w-5 shrink-0 text-pink-500" />
                                <span>
                                    <span className="block text-[11px] uppercase tracking-[0.2em] text-cream/50">
                                        Instagram
                                    </span>
                                    <span className="block text-sm font-semibold">
                                        @ishaan_worldlink
                                    </span>
                                </span>
                            </a>

                        </div>
                        <p className="mt-auto flex items-start gap-2 pt-10 text-xs leading-relaxed text-cream/50">
    <MapPin className="mt-0.5 h-3.5 w-3.5 shrink-0" />
    <span>
        Registered Office: A-117, Kutch Arcade Titanium, NH-8/A, Mithirohar,
        Gandhidham (Kachchh) - 370240, Gujarat (IN)
    </span>
</p>
                    </div>
                </div>

                <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-linedark pt-6 sm:flex-row sm:items-center">
                    <p className="text-xs text-cream/45">
                        © {new Date().getFullYear()} ISHAAN WORLDLINK LLP. All rights reserved.
                    </p>
            
                </div>
            </div>
        </footer>
    );
}
